import { AudioManager } from "../../../AudioManager";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { Button } from "../../../utils/Utils";
import { BoardManager } from "../BoardManager";
import { ReRollDemoContainer } from "./ReRollDemoContainer";
import { TurnDemoContainer } from "./TurnDemoContainer";

export class RulesLayer extends Phaser.GameObjects.Container {

    private scaledItemsContainer: Phaser.GameObjects.Container;
    private reRollDemoContainer: ReRollDemoContainer;
    private rulesSet1: Phaser.GameObjects.Container;
    private rulesSet2: Phaser.GameObjects.Container;
    private rulesSet3: Phaser.GameObjects.Container;
    private paginationCircle1: Phaser.GameObjects.Graphics;
    private paginationCircle2: Phaser.GameObjects.Graphics;
    private paginationCircle3: Phaser.GameObjects.Graphics;
    private leftArrow: Button;
    private rightArrow: Button;
    private i: number;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.i = 1;

        const tmpBackground = new Phaser.GameObjects.Graphics(this.scene);
        tmpBackground.fillStyle(0x153149);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_HEIGHT, GameConstants.GAME_HEIGHT);
        tmpBackground.alpha = .5;
        this.add(tmpBackground);

        this.scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(this.scaledItemsContainer);

        this.addMenuBackground();

        this.addRulesSet1();
        this.addRulesSet2();
        this.addRulesSet3();

        this.rulesSet1.visible = true;
        this.rulesSet2.visible = false;
        this.rulesSet3.visible = false;

        this.leftArrow = new Button(this.scene, -235, 295, "texture_atlas_1", "btn_arrow", "btn_arrow");
        this.leftArrow.scaleX = -1;
        this.leftArrow.visible = false;
        this.leftArrow.onDown(this.onClickLeftArrow, this);
        this.scaledItemsContainer.add(this.leftArrow); 

        this.rightArrow = new Button(this.scene, 235, 295, "texture_atlas_1", "btn_arrow", "btn_arrow");
        this.rightArrow.onDown(this.onClickRightArrow, this);
        this.scaledItemsContainer.add(this.rightArrow); 

        // EL BOTON DE CERRAR EL MENU
        const closeButton = new Button(this.scene, 285, -420, "texture_atlas_1", "btn_close_off", "btn_close_on");
        closeButton.onDown(this.onCloseMenu, this);
        this.scaledItemsContainer.add(closeButton);
    }

    public update(): void {

        this.reRollDemoContainer.update();
    }

    private addMenuBackground(): void {

        const w = 585;
        const h = 770;

        const menuBackground = new Phaser.GameObjects.Graphics(this.scene);
        menuBackground.fillStyle(0x153149);
        menuBackground.fillRect(-w / 2, -h / 2 - 10, w, h);
        this.scaledItemsContainer.add(menuBackground);

        let leftFrame = new Phaser.GameObjects.Image(this.scene, -296, -320, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -296, leftFrame.y + leftFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -296, leftFrame.y + leftFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -296, leftFrame.y + leftFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -296, leftFrame.y + leftFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -296, leftFrame.y + leftFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -296, leftFrame.y + leftFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(leftFrame);
        leftFrame = new Phaser.GameObjects.Image(this.scene, -296, leftFrame.y + leftFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(leftFrame);

        let rightFrame = new Phaser.GameObjects.Image(this.scene, 298, -320, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 298, rightFrame.y + rightFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 298, rightFrame.y + rightFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 298, rightFrame.y + rightFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 298, rightFrame.y + rightFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 298, rightFrame.y + rightFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 298, rightFrame.y + rightFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(rightFrame);
        rightFrame = new Phaser.GameObjects.Image(this.scene, 298, rightFrame.y + rightFrame.height, "texture_atlas_2", "frame_border");
        this.scaledItemsContainer.add(rightFrame);

        const upperFrame = new Phaser.GameObjects.Image(this.scene, 0, -400, "texture_atlas_2", "rules_bar");
        this.scaledItemsContainer.add(upperFrame);

        const lowerFrame = new Phaser.GameObjects.Image(this.scene, 0, 360, "texture_atlas_2", "rules_bar_bottom");
        this.scaledItemsContainer.add(lowerFrame);

        const menuTitle = new Phaser.GameObjects.Image(this.scene, 0, upperFrame.y - 15, "texture_atlas_3", "title_rules");
        this.scaledItemsContainer.add(menuTitle);

        this.paginationCircle1 = new Phaser.GameObjects.Graphics(this.scene);
        this.paginationCircle1.fillStyle(0x00e8f2);
        this.paginationCircle1.fillCircle(-20, 295, 6);
        this.scaledItemsContainer.add(this.paginationCircle1);

        this.paginationCircle2 = new Phaser.GameObjects.Graphics(this.scene);
        this.paginationCircle2.fillStyle(0x00e8f2);
        this.paginationCircle2.fillCircle(0, 295, 6);
        this.paginationCircle2.alpha = .35;
        this.scaledItemsContainer.add(this.paginationCircle2);

        this.paginationCircle3 = new Phaser.GameObjects.Graphics(this.scene);
        this.paginationCircle3.fillStyle(0x00e8f2);
        this.paginationCircle3.fillCircle(20, 295, 6);
        this.paginationCircle3.alpha = .35;
        this.scaledItemsContainer.add(this.paginationCircle3);
    }

    private addRulesSet1(): void {

        this.rulesSet1 = new Phaser.GameObjects.Container(this.scene);
        this.scaledItemsContainer.add(this.rulesSet1);

        const diagramGrid =  new Phaser.GameObjects.Image(this.scene, 0, -150, "texture_atlas_2", "diagram_grid");
        this.rulesSet1.add(diagramGrid);

        let str = "Drag pieces from the DASHBOARD to the GRID.";

        const paragraph1 = new Phaser.GameObjects.Text(this.scene, 0, 100, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph1.setOrigin(.5);
        this.rulesSet1.add(paragraph1);

        str = "Each released piece on the GRID will give you points.";

        const paragraph2 = new Phaser.GameObjects.Text(this.scene, 0, 145, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph2.setOrigin(.5);
        this.rulesSet1.add(paragraph2);

        str = "Clear all the pieces of a column or a row by filling all\nits gaps.";

        const paragraph3 = new Phaser.GameObjects.Text(this.scene, 0, 200, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph3.setOrigin(.5);
        this.rulesSet1.add(paragraph3);
    }

    private addRulesSet2(): void {

        this.rulesSet2 = new Phaser.GameObjects.Container(this.scene);
        this.scaledItemsContainer.add(this.rulesSet2);

        const diagramGrid =  new Phaser.GameObjects.Image(this.scene, 0, -150, "texture_atlas_2", "diagram_grid");
        this.rulesSet2.add(diagramGrid);

        let str = "Clear the DASHBOARD to get a new batch of 3 pieces.";

        const paragraph1 = new Phaser.GameObjects.Text(this.scene, 0, 100, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph1.setOrigin(.5);
        this.rulesSet2.add(paragraph1);

        str = "Use the HOLDER to hold pieces for later.";

        const paragraph2 = new Phaser.GameObjects.Text(this.scene, 0, 144, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph2.setOrigin(.5);
        this.rulesSet2.add(paragraph2);

        str = "Once a piece is put on hold it can't be dragged back to\nthe DASHBOARD.";

        const paragraph3 = new Phaser.GameObjects.Text(this.scene, 0, 200, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph3.setOrigin(.5);
        this.rulesSet2.add(paragraph3);
    }
    
    private addRulesSet3(): void {

        this.rulesSet3 = new Phaser.GameObjects.Container(this.scene);
        this.scaledItemsContainer.add(this.rulesSet3);

        const turnDemoContainer = new TurnDemoContainer(this.scene);
        turnDemoContainer.x = -150;
        turnDemoContainer.y = -90;
        this.rulesSet3.add(turnDemoContainer);

        this.reRollDemoContainer = new ReRollDemoContainer(this.scene);
        this.reRollDemoContainer.x = 150;
        this.reRollDemoContainer.y = -90;
        this.rulesSet3.add(this.reRollDemoContainer);

        let str = "You can also put pieces in the HOLDER to make use of\nthe features.";

        const paragraph1 = new Phaser.GameObjects.Text(this.scene, 0, -320, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph1.setOrigin(.5);
        this.rulesSet3.add(paragraph1);

        str = "You can get more TURN of RE-ROLL features by clearing\nsimultaneously a column AND a row (CROSS CLEAR).";

        const paragraph2 = new Phaser.GameObjects.Text(this.scene, 0, 100, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph2.setOrigin(.5);
        this.rulesSet3.add(paragraph2);

        str = "The game will be over once you can't place more\npieces on the GRID or in the HOLDER.";

        const paragraph3 = new Phaser.GameObjects.Text(this.scene, 0, 210, str, {fontFamily: "Futura-Medium", fontSize: "21px", color: "#FFFFFF", align: "center"});
        paragraph3.setOrigin(.5);
        this.rulesSet3.add(paragraph3);
    }

    private onCloseMenu(): void {

        if (!this.scene) {
            return;
        }

        BoardManager.currentInstance.removeRules();

        AudioManager.playSound("btn_feature_pressed");
    }

    private onClickRightArrow(): void {

        this.i ++;

        if (this.i === 2) {

            this.rulesSet1.visible = false;
            this.rulesSet2.visible = true;
            this.rulesSet3.visible = false;

            this.leftArrow.visible = true;
            this.rightArrow.visible = true;

            this.paginationCircle1.alpha = .35;
            this.paginationCircle2.alpha = 1;
            this.paginationCircle3.alpha = .35;

        } else {

            this.rulesSet1.visible = false;
            this.rulesSet2.visible = false;
            this.rulesSet3.visible = true;

            this.leftArrow.visible = true;
            this.rightArrow.visible = false;

            this.paginationCircle1.alpha = .35;
            this.paginationCircle2.alpha = .35;
            this.paginationCircle3.alpha = 1;
        }

        AudioManager.playSound("btn_feature_pressed");
    }

    private onClickLeftArrow(): void {

        this.i --;

        if (this.i === 1) {

            this.rulesSet1.visible = true;
            this.rulesSet2.visible = false;
            this.rulesSet3.visible = false;

            this.leftArrow.visible = false;
            this.rightArrow.visible = true;

            this.paginationCircle1.alpha = 1;
            this.paginationCircle2.alpha = .35;
            this.paginationCircle3.alpha = .35;

        } else {

            this.rulesSet1.visible = false;
            this.rulesSet2.visible = true;
            this.rulesSet3.visible = false;

            this.leftArrow.visible = true;
            this.rightArrow.visible = true;

            this.paginationCircle1.alpha = .35;
            this.paginationCircle2.alpha = 1;
            this.paginationCircle3.alpha = .35;
        }

        AudioManager.playSound("btn_feature_pressed");
    }
}
